import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Lock, ArrowUpRight, AlertCircle } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import BrandMark from '@/components/site/BrandMark';
import { toast } from 'sonner';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) { setErr(error.message); toast.error(error.message); return; }
    toast.success('Welcome back.');
    nav('/admin');
  };

  return (
    <>
      <Helmet><title>Admin — Slinkflow</title></Helmet>
      <div className="relative min-h-screen overflow-hidden bg-white">
        <div className="absolute -top-32 left-0 h-[520px] w-[520px] hero-gradient-orb" />
        <div className="absolute right-0 bottom-0 h-[420px] w-[420px] hero-orb-2" />
        <div className="relative mx-auto flex min-h-screen max-w-[1400px] items-center justify-center px-6 py-16">
          <div className="w-full max-w-md rounded-3xl border border-ink-100 bg-white p-10 shadow-medium">
            <Link to="/"><BrandMark size="md" /></Link>
            <h1 className="mt-10 font-display text-3xl text-ink-900">Sign in to the studio.</h1>
            <p className="mt-2 text-sm text-ink-500">Admin access only.</p>
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-ink-400">Email</label>
                <input data-testid="admin-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 w-full rounded-2xl border border-ink-100 bg-ink-50/40 px-5 py-3.5 focus:border-cyan focus:outline-none focus:ring-2 focus:ring-cyan/20" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-ink-400">Password</label>
                <input data-testid="admin-password" type="password" required value={password} onChange={e=>setPassword(e.target.value)} className="mt-2 w-full rounded-2xl border border-ink-100 bg-ink-50/40 px-5 py-3.5 focus:border-cyan focus:outline-none focus:ring-2 focus:ring-cyan/20" />
              </div>
              {err && <div className="flex items-center gap-2 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-600"><AlertCircle className="h-4 w-4" /> {err}</div>}
              <button data-testid="admin-submit" disabled={loading} className="btn-cyan inline-flex w-full items-center justify-center gap-2 rounded-full py-3.5 text-sm font-medium">
                {loading ? 'Signing in…' : <>Sign in <ArrowUpRight className="h-4 w-4" /></>}
              </button>
            </form>
            <p className="mt-6 text-xs text-ink-400 flex items-center gap-2"><Lock className="h-3 w-3" /> Protected by Supabase Auth + RLS.</p>
          </div>
        </div>
      </div>
    </>
  );
}
